import React from 'react';

import PropTypes from 'prop-types';

import { MediaCard } from '@adsk/acc-sitevision-web-lib';
import { Box } from '@adsk/alloy-react-box';

/**
 * A component rendering Photo entity picker item.
 * @param entity
 * @param rest
 * @returns {*}
 * @constructor
 */
const PhotoEntityPickerItem = ({ onChange, selected, entity, disabled }) => {
  return (
    <Box width="50%" padding="8px" display="inline-block" verticalAlign="top">
      <MediaCard
        media={{ ...entity, uid: entity.id }}
        disabled={disabled}
        selected={selected}
        onChange={() => {
          onChange(!selected);
        }}
        onClick={() => {
          onChange(!selected);
        }}
      />
    </Box>
  );
};

PhotoEntityPickerItem.propTypes = {
  /**
   * The Photo entity we need to render.
   */
  entity: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string,
    createdAt: PropTypes.string,
    takenOn: PropTypes.string,
    takenBy: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
    }),
    thumbnailUrl: PropTypes.string,
  }).isRequired,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onChange: PropTypes.func,
};

export default PhotoEntityPickerItem;
